import { render, staticRenderFns } from "./Ukuran.vue?vue&type=template&id=1b4a6bb6&"
import script from "./Ukuran.vue?vue&type=script&lang=js&"
export * from "./Ukuran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports